module.exports = __webpack_public_path__ + "static/img/glove_laurier.e53ffe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_laurier.png
// module id = JZ/3
// module chunks = 0